import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import SectionHeader from '@/components/feature/SectionHeader';
import DramaCard from '@/components/feature/DramaCard';
import { featuredDramas, latestDramas, hotDramas, categories } from '@/mocks/dramas';

export default function Home() {
  const latest = latestDramas.slice(0, 10);
  const hot = hotDramas.slice(0, 10);

  return (
    <div className="w-full">
      <HeroCarousel dramas={featuredDramas} />

      <div className="mx-auto max-w-content px-4 md:px-6">
        <section className="relative z-20 -mt-10 rounded-lg border border-background-200 bg-background-50 p-5 md:-mt-12 md:p-6">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">按分类找剧</h2>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">选择你感兴趣的剧集类型，快速定位心仪好剧</p>
            </div>
            <Link
              to="/category/guochan"
              className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-accent-600 sm:flex"
            >
              全部分类
              <i className="ri-arrow-right-s-line text-lg" />
            </Link>
          </div>
          <CategoryEntry />
        </section>

        <section className="mt-14">
          <SectionHeader
            title="最新上线"
            subtitle="按更新时间倒序，第一时间追上新剧进度"
            moreTo="/category/guochan"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {latest.map((d) => (
              <DramaCard key={d.id} drama={d} />
            ))}
          </div>
        </section>

        <section className="mt-14 rounded-lg bg-background-100 p-5 md:p-8">
          <SectionHeader title="热门推荐" subtitle="依据近期播放热度整理的必追剧集" moreTo="/category/dushi" />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {hot.map((d) => (
              <DramaCard key={d.id} drama={d} />
            ))}
          </div>
        </section>

        <section className="mt-14 overflow-hidden rounded-lg border border-background-200 bg-primary-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-6 md:p-10">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                <i className="ri-fire-line" />
                关于最新电视剧
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                追剧不迷路，好剧不错过
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                最新电视剧网站专注于为电视剧爱好者提供当前最热门的影视剧推荐与剧情介绍。
                我们持续整理国产剧、韩剧、美剧、古装剧与都市剧的最新动态，帮助你快速查找热门新剧、了解剧集详情、播出时间与观看信息。
              </p>
              <div className="mt-6 grid grid-cols-3 gap-4">
                {[
                  { num: '20+', label: '在库剧集' },
                  { num: '5', label: '剧集分类' },
                  { num: '每日', label: '更新动态' },
                ].map((s) => (
                  <div key={s.label} className="rounded-lg bg-background-50 p-4">
                    <p className="font-heading text-2xl font-bold text-primary-600">{s.num}</p>
                    <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                  </div>
                ))}
              </div>
              <Link
                to="/about"
                className="mt-6 inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                了解我们
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="relative min-h-[240px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20collage%20of%20television%20screens%20and%20glowing%20film%20scenes%20in%20deep%20blue%20tones%20with%20warm%20orange%20highlights%2C%20abstract%20modern%20media%20wall%20composition%2C%20minimal%20clean%20studio%20atmosphere%2C%20editorial%20entertainment%20style%2C%20high%20detail&width=900&height=800&seq=home-intro-panel&orientation=portrait"
                alt="最新电视剧内容展示"
                title="最新电视剧推荐与剧情介绍"
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/50 to-transparent lg:bg-gradient-to-r lg:from-primary-50/60 lg:to-transparent" />
            </div>
          </div>
        </section>

        <section className="mb-4 mt-14">
          <SectionHeader title="热门标签" subtitle="按题材标签发现更多好剧" />
          <div className="flex flex-wrap gap-3">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-price-tag-3-line text-accent-500" />
                {c.name}
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}